import { render, staticRenderFns } from "./SupportUpdate.vue?vue&type=template&id=06566525&scoped=true&"
import script from "./SupportUpdate.vue?vue&type=script&lang=js&"
export * from "./SupportUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06566525",
  null
  
)

export default component.exports